<div class="layout-topbar">
    <div class="layout-topbar-wrapper">
        <div class="layout-topbar-left">
            <a href="#" class="sidebar-menu-button" (click)="appMain?.onMenuButtonClick($event)">
                <i class="pi pi-bars"></i>
            </a>

            <div class="layout-topbar-logo-wrapper">
                <a href="#" class="layout-topbar-logo">
                    <img [src]="urlImageLogo" [alt]="marca" />
                    <span class="app-name">{{marca}}</span>
                </a>
            </div>

            <app-context-switcher
                [shortcuts]="shortcuts"
                [printerVisible]="isTypeClientPrintCoffe"
                [printerConnected]="statusClientPrinterCoffe"
                (printerClick)="printerClientsVisible = true"
                [whatsappVisible]="whatsappVisible"
                [whatsappConnected]="whatsappConnected"
                [whatsappRoute]="whatsappRoute">
            </app-context-switcher>
        </div>
        <div class="layout-topbar-right">
            <ul class="layout-topbar-actions">
                <li class="topbar-item topbar-shortcuts" *ngIf="shortcuts?.length">
                    <a *ngFor="let item of inlineShortcuts" class="shortcut-button" [routerLink]="item?.ruta" [queryParams]="item?.queryParams"
                       [pTooltip]="item?.nombre" tooltipPosition="bottom">
                        <i *ngIf="item?.icono" [class]="'topbar-icon ' + (item.icono | iconoPrime)"></i>
                    </a>
                    <span class="shortcut-divider"></span>
                    <a class="shortcut-button shortcut-more" (click)="shortcutsMenu.toggle($event)"
                       pTooltip="Accesos directos" tooltipPosition="bottom">
                        <i class="topbar-icon pi pi-ellipsis-h"></i>
                    </a>
                    <p-menu #shortcutsMenu [popup]="true" [model]="shortcutsMenuItems" appendTo="body"></p-menu>
                </li>

                <li class="topbar-actions-divider" *ngIf="shortcuts?.length && (isTypeClientPrintCoffe || whatsappVisible)"></li>

                <li class="topbar-item topbar-status-item" *ngIf="isTypeClientPrintCoffe">
                    <button type="button" class="status-icon" (click)="printerClientsVisible = true"
                       [attr.aria-label]="printerConnectionLabel + ' Abrir equipos de impresión.'"
                       aria-haspopup="dialog"
                       [pTooltip]="printerConnectionLabel + ' Ver equipos de toda la empresa.'"
                       tooltipPosition="bottom">
                        <i class="pi pi-print"></i>
                        <span class="status-dot" [class.is-ok]="statusClientPrinterCoffe" [class.is-off]="!statusClientPrinterCoffe"></span>
                    </button>
                </li>
                <li class="topbar-item topbar-status-item" *ngIf="whatsappVisible">
                    <a class="status-icon" [routerLink]="whatsappRoute"
                       [pTooltip]="whatsappConnected ? 'WhatsApp: sesión activa' : 'WhatsApp: sin sesión, clic para conectar'"
                       tooltipPosition="bottom">
                        <i class="pi pi-whatsapp"></i>
                        <span class="status-dot" [class.is-ok]="whatsappConnected" [class.is-off]="!whatsappConnected"></span>
                    </a>
                </li>

                <li class="topbar-actions-divider" *ngIf="shortcuts?.length || isTypeClientPrintCoffe || whatsappVisible"></li>

                <li class="topbar-item topbar-notifications">
                    <app-notification-indicator></app-notification-indicator>
                </li>

                <li #profile class="topbar-item profile-item" [ngClass]="{'active-topmenuitem': appMain?.activeTopbarItem === profile}">
                    <a href="#" (click)="appMain?.onTopbarItemClick($event,profile)"
                       [pTooltip]="appMain?.userLogin?.name" tooltipPosition="bottom">
                        <span class="profile-image-wrapper">
                            <img [src]="appMain?.userLogin?.avatarUrl" (error)="onAvatarError($event)" alt="avatar"/>
                        </span>
                        <span class="profile-info-wrapper">
                            <h3>{{appMain?.userLogin?.name}}</h3>
                            <span>{{appMain?.userLogin?.cargo}}</span>
                        </span>
                    </a>
                    <ul class="profile-item-submenu fadeInDown">
                        <li class="profile-submenu-header">
                            <div class="performance">
                                <span>{{appMain?.razonSocial}}</span>
                                <img src="assets/layout/images/topbar/asset-bars.svg" alt="" />
                            </div>
                            <div class="profile">
                                <img [src]="appMain?.userLogin?.avatarUrl" (error)="onAvatarError($event)" alt="avatar" width="40"/>
                                <h1>{{appMain?.userLogin?.name}}</h1>
                                <span>{{appMain?.userLogin?.cargo}}</span>
                            </div>
                        </li>
                        <li *appPermission="'CAMBIAR_CONFIGURACION'" routerLink="/mi-empresa" class="layout-submenu-item">
                            <span class="pi pi-cog icon icon-1"></span>
                            <div class="menu-text">
                                <p>Configuración</p>
                            </div>
                        </li>
                        <li routerLink="/facturacion" class="layout-submenu-item">
                            <span class="pi pi-money-bill icon icon-1"></span>
                            <div class="menu-text">
                                <p>Facturación</p>
                            </div>
                        </li>
                        <li routerLink="/mi-perfil" class="layout-submenu-item">
                            <span class="pi pi-user icon icon-1"></span>
                            <div class="menu-text">
                                <p>Mi perfil</p>
                            </div>
                        </li>
                        <li routerLink="/cambiar-clave" class="layout-submenu-item">
                            <span class="pi pi-user icon icon-1"></span>
                            <div class="menu-text">
                                <p>Cambiar contraseña</p>
                            </div>
                        </li>
                        <li class="theme-profile-entry"><app-theme-toggle></app-theme-toggle></li>
                        <li class="layout-submenu-footer">
                            <button routerLink="/logout" class="signout-button">Salir</button>
                            <span class="app-version">{{marca}} v{{appVersion$ | async}}</span>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </div>
</div>

<app-printer-clients-dialog *ngIf="isTypeClientPrintCoffe" [(visible)]="printerClientsVisible"></app-printer-clients-dialog>
